export const DATE_PICKER_INPUT_DEFAULT_VALUE = '__/____';
export const DATE_PICKER_MIN_YEAR = 1900;
